export default __webpack_public_path__ + "static/media/relative-bold-pro.419c53fd.ttf";